import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close\"><defs><style></style></defs><path d=\"M810.667 273.493l-60.16-60.16L512 451.84 273.493 213.333l-60.16 60.16L451.84 512 213.333 750.507l60.16 60.16L512 572.16l238.507 238.507 60.16-60.16L572.16 512z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol